module.exports = __webpack_public_path__ + "static/mistletone-f60187310de45976261df2b2ec6b42f4.png";